import React from "react";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import { AdminButton } from "../buttons/versionHistoryBtn";

import { Form, Formik } from "formik";
import * as Yup from "yup";
import "./modal.css";

import SendMailCFATable from "../tables/sendMailCFATable";

const SendMailTableModal = ({ sendMailShow, handleSendMailShowClose }) => {
  return (
    <Modal
      centered
      show={sendMailShow}
      onHide={handleSendMailShowClose}
      dialogClassName="distributor-reimburse-table-container"
      size="lg"
    >
      <ModalHeader>
        <span className="fn_Nunito fw_700 fs_16 Medium_Purple my- px-0">
          Send mail to CFA
        </span>
      </ModalHeader>

      <ModalBody>
        <div>
          <div className="mx-2 my-2 mb-3">
            {data.map((items) => (
              <div className="d-flex gap-">
                <div className="col-4 col-lg-2 ">
                  <span className="color_b0b3c7 fs_14 fs_sm_12">{items.title}</span>
                </div>
                <span className="fs_14 fs_sm_12 ms-3">{items.content}</span>
              </div>
            ))}
          </div>
          <SendMailCFATable />
        </div>
        <div className="d-flex justify-content-end mt-3">
          <div className="d-flex justify-content-end mt-3 me-2 gap-2">
            <button
              className="modal-back-btn px-5 py-1 fs_12 fw_600"
              onClick={() => handleSendMailShowClose()}
            >
              Back
            </button>
            <div>
              <button
                className="modal-submit-btn text-white px-4 py-2 fs_12"
                type="submit"
              >
                <span className="px-4">Send</span>
              </button>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default SendMailTableModal;
const data = [
  {
    title: "CFA’s Email Adreess",
    content: "cfa@jivini.com",
  },
  {
    title: "CC to",
    content: "mr@jivini.com | reportingmanager@jivini.com",
  },
  {
    title: "Subject",
    content: "Place the mentioned order.",
  },
];
